import {ApolloClient,createHttpLink,InMemoryCache} from '@apollo/client'


const httpLink = createHttpLink({
    uri: "https://mensajess.herokuapp.com/"
})

const client = new ApolloClient({
    connectToDevTools:true,
    cache: new InMemoryCache(),
    link: httpLink
})

export default client